export default __webpack_public_path__ + "static/logo-raleigh-427d572e5ded4067897f359c045482de.jpg";